import "../assets/css/header.css";
import React from "react";
import { Link } from "react-router-dom";
import { mobileNav } from "../Helper/CssHelper";
// import HeaderData from "../data/HeaderData";

function Header(props) {
  let HeaderData = props.HeaderData;
  return (
    <div>
      <header id="header">
        <div className="container">
          {HeaderData.name && (
            <h1>
              <Link to="/">{HeaderData.name}</Link>
            </h1>
          )}
          {HeaderData.role && (
            <h2>
              I'm a passionate <span>{HeaderData.role}</span>
            </h2>
          )}

          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <Link id="home" className="home nav-link active" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link id="aboutme" className="nav-link" to="/AboutMe">
                  About
                </Link>
              </li>
              <li>
                <Link id="resume" className="nav-link" to="/Resume">
                  Resume
                </Link>
              </li>
              {/* <li><Link id = "services" className="nav-link" to="/Services">Services</Link></li> */}
              <li>
                <Link id="projects" className="nav-link" to="/Projects">
                  Projects
                </Link>
              </li>
              <li>
                <Link id="certifications" className="nav-link" to="/Certifications">
                  Certifications
                </Link>
              </li>
              <li>
                <Link id="contact" className="nav-link" to="/Contact">
                  Contact
                </Link>
              </li>
            </ul>
            <i onClick={mobileNav} className="bi bi-list mobile-nav-toggle"></i>
          </nav>
          {/* <!-- .navbar --> */}

          <div className="social-links">
            {HeaderData.socialLinks &&
              HeaderData.socialLinks.map((item, index) => {
                return (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    className={item.name}
                    key={index}
                  >
                    <i className={`${item.className}`}></i>
                  </a>
                );
              })}
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
